export default __webpack_public_path__ + "static/media/O_Ovo.35c26060.mp3";